<template>
	<span>
        <span @click="mostra = !mostra" :class="estilo">
            <!-- <i class="fa" :class="iconeBotaoMostra" aria-hidden="true" v-if="!mostra"></i>
            <i class="fa" :class="iconeBotaoEsconde" aria-hidden="true" v-else></i> -->
            <i class="fa fa-chevron-circle-down" aria-hidden="true" v-if="!mostra"></i>
            <i class="fa fa-chevron-circle-up" aria-hidden="true" v-else></i>
        </span> 
        <transition name="fade"> 
            <div v-show="mostra">
                <slot></slot>
            </div>
        </transition>
	</span>
</template>

<script>
export default {
    
    data() {
        return {
            mostra: false
        }
    },

	props: {
        estilo: {
            required: false,
            default: "",
            type: String
        },
        iconeMostra: {
            required: false,
            default: "",
            type: String
        },
        iconeEsconde: {
            required: false,
            default: "",
            type: String
        }, 
        
    },
	methods: {
		
	},
	computed: {
		
        iconeBotaoMostra() {
			if(this.iconeMostra == 'interrogacao') return 'fa-question-circle-o';
            if(this.iconeMostra == 'seta-abaixo') return 'fa-chevron-circle-down';
            else return this.icone;
        },
        iconeBotaoEsconde() {
			if(this.iconeEsconde == 'interrogacao') return 'fa-question-circle-o';
            if(this.iconeEsconde == 'seta-acima') return 'fa-chevron-circle-up';
            else return this.icone;
        },
	}
}
</script>

<style scoped>
.fa {
    /* color: #b6c0c0; */
    opacity: 0.3;
	cursor: pointer;
}
</style>





// WEBPACK FOOTER //
// index.vue?eeea0b86